export const foldersKeys = {
  all: () => ['FOLDERS'] as const,
};
